import { render, staticRenderFns } from "./AddParticipantIcon.vue?vue&type=template&id=2d0b7b1c&"
import script from "./AddParticipantIcon.vue?vue&type=script&lang=js&"
export * from "./AddParticipantIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports